<template>
  <div class="about">
    <div class="banner">
      <img src="../../assets/img/about/banner.jpg" />
      <div class="banner-text">
        <div class="container wow slideInLeft">
          <h1>{{$t("about.banner.bannerTitle")}}</h1>
          <p>{{$t("about.banner.bannerP")}}</p>
        </div>
      </div>
    </div>

    <div class="company" id="company">
      <div class="container">
        <div class="headline">
          <h1>{{$t("about.company.headlineTitle")}}</h1>
          <p>{{$t("about.company.headlineP")}}</p>
        </div>

        <el-row :gutter="30">
          <el-col :span="14" :xs="24">
            <div data-swiper-parallax="-300" data-swiper-parallax-duration="1000">
              <h2>
                <span class="company-name">{{$t("home.company.companyName")}}</span>
                <span class="line">__</span>
                <span class="name-tag">{{$t("home.company.nameTag")}}</span>
              </h2>
              <p class="introduce" v-for="(item,index) in this.groupIntroduction" :key="index">{{item}}</p>

            </div>
          </el-col>
          <el-col :span="10" :xs="24">
            <video width="100%"  preload="metadata" controls muted playsinline autoplay class="video">
              <source src="../../assets/img/about/hqh.mp4" type="video/mp4" >
            </video>
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="message-from-chairman">
      <div class="container">
        <div class="box">
          <h2>{{$t("about.messageFromChairman.title")}}</h2>
          <div class="des" v-for="(item,index) in this.messageFromChairman" :key="index" >{{item}}</div>
        </div>
      </div>
    </div>
    <div class="history hidden-sm-and-up" id="history" >
      <div class="headline">
        <h1>{{$t("about.history.headlineTitle")}}</h1>
        <p>{{$t("about.history.headlineP")}}</p>
      </div>
      <div class="history-position">
        <div class="container">
            <el-timeline>
              <el-timeline-item
                v-for="(item,index) in history"
                :key="index"
                :timestamp="item.companyContent"
                color="#0054a7">
                {{ item.startYear.slice(0,4) }}
              </el-timeline-item>
            </el-timeline>
        </div>
      </div>
      
    </div>
    <div class="history hidden-xs-only" id="history">
      
      <!-- <div class="history-position"  @scroll="historyScroll">
        <div class="container">
          <el-row :gutter="60">
            <el-col :span="8" :xs="24" >
              <div class="pic">
                <img src="../../assets/img/about/dqc.png" />
              </div>
            </el-col>
            <el-col :span="16" :xs="24">
              <div class="swiper-wrap">
                <swiper :options="swiperOption"  class="history-swiper" @slideChange="slideChange" ref="indexSwiper">
                  <swiper-slide class="swiper-slide" v-for="(item,index) in history" :key="index">
                    <h2>{{item.startYear.slice(0,4)}}</h2>
                    <p>{{item.companyContent}}</p>
                  </swiper-slide>
                  <div class="swiper-scrollbar" slot="scrollbar"></div>
                </swiper>
                <div class="year" v-if="history[yearIndex+2] && history[yearIndex]">{{history[yearIndex+2].startYear.slice(0,4)}} — {{history[yearIndex].startYear.slice(0,4)}}</div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div> -->
      <div class="container">
        <div class="headline">
          <h1>{{$t("about.history.headlineTitle")}}</h1>
          <p>{{$t("about.history.headlineP")}}</p>
        </div>
        <el-tabs v-model="activeName"  tab-position="bottom" :stretch="true">
          <el-tab-pane v-for="(i,index) in Math.ceil(history.length/3) " :key="index"  :name="'pane'+index">
            <template #label>
              <span >{{ history[index*3].startYear.slice(0,4) }} <span>——</span> {{ history[index*3+2] ? history[index*3+2].startYear.slice(0,4): history[index*3+1] ? history[index*3+1].startYear.slice(0,4) : history[index*3+0].startYear.slice(0,4)}}</span>
            </template>

            <el-row :gutter="60">
              <el-col :span="12"  >
                <div class="pic">
                  <img :src="require(`../../assets/img/about/pane${ index+1 }.jpg`)" />
                </div>
              </el-col>
              <el-col :span="12">
                <div class="box-wrap">
                  <div class="box" v-for="item in history.slice(index*3,index*3+3)" :key="item.companyContentNo">
                    <h2>{{item.startYear.slice(0,4)}}</h2>
                    <p>{{item.companyContent}}</p>
                  </div>
                </div>
              </el-col>
            </el-row>
          </el-tab-pane>
        </el-tabs>
      </div>
      
    </div>

    <div class="culture hidden-xs-only" id="culture">
      <div class="container">
        <div class="headline">
          <h1>{{$t("about.culture.headlineTitle")}}</h1>
          <p>{{$t("about.culture.headlineP")}}</p>
        </div>
        
        <el-row :gutter="60">
          <el-col :span="6" class="culture-des">
            <div class="culture-block">
              <h2>{{sectionOne.title}}</h2>
              <div v-html="sectionOne.des"></div>
            </div>
          </el-col>
          <el-col :span="18"  >
            <el-row class="culture-row" :class="cultureBg">
              <el-col :span="4" v-for="(item,index) in $t('about.culture.section')" :key="index" @mouseover.native="handleSection(index)">
                 <h2 :class="language=='cn'?'':'vertical'">{{item.title}}</h2>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        
      </div>
    </div>
    <div class="honor" id="honor">
      <div class="container">
        <div class="headline">
          <h1>{{$t("about.honor.headlineTitle")}}</h1>
          <p>{{$t("about.honor.headlineP")}}</p>
        </div>
        <el-row :gutter="60" class="first-row">
          <el-col :span="8" :xs="24">
            <div class="pic">
              <img src="../../assets/img/about/honor1.jpg" alt="">
            </div>
          </el-col>
          <el-col :span="8" :xs="24">
            <div class="pic">
              <img src="../../assets/img/about/honor2.jpg" alt="">
            </div>
          </el-col>
          <el-col :span="8" :xs="24">
            <div class="pic">
              <img src="../../assets/img/about/honor3.jpg" alt="">
            </div>
          </el-col>
        </el-row>
        <div class="honor-swiper hidden-xs-only">
          <!-- <swiper :options="honorOption" >
            <swiper-slide class="swiper-slide" v-for="(item,index) in honorLists" :key="index">
              <img :src="item.picturePath" alt=""/>
            </swiper-slide>
          </swiper>
          <div class="swiper-button-prev"></div>
          <div class="swiper-button-next"></div> -->

          <el-carousel :interval="4000" type="card" height="300px">
            <el-carousel-item v-for="(item,index) in honorLists" :key="index">
              <img :src="item.picturePath" alt="" style="width:100%;height:100%;object-fit: contain;"/>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>
    <div class="team-style" id="teamStyle">
      <div class="container">
        <div class="team-style-box">
          <div class="headline">
            <h1>{{$t("about.teamStyle.headlineTitle")}}</h1>
            <p>{{$t("about.teamStyle.headlineP")}}</p>
          </div>
          
          <div class="swiper-box">
            <swiper :options="teamStyleOption" v-if="teamStyleLists.length">
              <swiper-slide class="swiper-slide" v-for="(item,index) in teamStyleLists" :key="index">
                <img :src="item.picturePath" alt=""/>
              </swiper-slide>
            </swiper>
          </div>
        </div>
      </div>
    </div>
    <!-- <el-row>
			<el-col :span="4" style="height:150px">
				<el-steps direction="vertical" :active="active" finish-status="success">
					<el-step title="作文一" @click.native="goRule('zwy')"></el-step>
					<el-step title="作文二" @click.native="goRule('zwe')"></el-step>
					<el-step title="作文三" @click.native="goRule('zws')"></el-step>
				</el-steps>
			</el-col>
			<el-col :span="20">
				  <div class="scoll_box" @scroll="onScroll" id="scrollElement" ref="myScroll">
						<span id="zwy" class="scroll-item">作文一</span>
						<el-divider></el-divider>
						<div class="scroll_content">
							内容1
						</div>
						<span id="zwe" class="scroll-item">作文二</span>
						<el-divider></el-divider>
						<div class="scroll_content">
			                内容2
						</div>
						<span id="zws" class="scroll-item">作文三</span>
						<el-divider></el-divider>
						<div class="scroll_content">
							内容3
						</div>
				</div>
			</el-col>
		</el-row> -->

  </div>
</template>

<script>
import {getstaticcontent,getpiclist} from "../../api/about"
import { mapGetters } from "vuex";
export default {
  name: "About",
  computed:{
    ...mapGetters(['language']),   
  },
  data() {
    return {
      swiperOption: {
        notNextTick: true, //notNextTick是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
        direction: "vertical", //水平方向移动
        grabCursor: true, //鼠标覆盖Swiper时指针会变成手掌形状，拖动时指针会变成抓手形状
        setWrapperSize: true, //Swiper使用flexbox布局(display: flex)，开启这个设定会在Wrapper上添加等于slides相加的宽或高，在对flexbox布局的支持不是很好的浏览器中可能需要用到。
        autoHeight: true, //自动高度。设置为true时，wrapper和container会随着当前slide的高度而发生变化
        slidesPerView: 3, //设置slider容器能够同时显示的slides数量(carousel模式)。可以设置为数字（可为小数，小数不可loop），或者 'auto'则自动根据slides的宽度来设定数量。loop模式下如果设置为'auto'还需要设置另外一个参数loopedSlides。
      slidesPerGroup : 3,
       mousewheel: true, //开启鼠标滚轮控制Swiper切换。可设置鼠标选项，默认值false
        mousewheelControl: true, //同上
        releaseOnEdges: true,//当Swiper处于边缘位置时（第一个或最后一个slide），Swiper释放鼠标滚轮事件，鼠标可以控制页面滚动。
       height: 600, // 高度设置，占满设备高度
        resistanceRatio: 0, //抵抗率。边缘抵抗力的大小比例。值越小抵抗越大越难将slide拖离边缘，0时完全无法拖离。本业务需要
        observeParents: true, //将observe应用于Swiper的父元素。当Swiper的父元素变化时，例如window.resize，Swiper更新
        // 如果自行设计了插件，那么插件的一些配置相关参数，也应该出现在这个对象中，如下debugger
        debugger: true,
        // swiper的各种回调函数也可以出现在这个对象中，和swiper官方一样
        on: {
          //监听滑动切换事件，返回swiper对象
          slideChange: () => {
            //let swiper = this.$refs.indexSwiper.swiper;
            //console.log(swiper.activeIndex); //滑动打印当前索引

          }
        },
        scrollbar: {
          el: '.swiper-scrollbar',
          draggable: true, // 该参数设置为true时允许拖动滚动条。
         // dragSize: 50 // 设置滚动条指示的尺寸。默认'auto': 自动，或者设置num(px)。
        },

      },
      active: 0,
      topNum:0,
      sectionOne:{},
      imgIndex:0,
      cultureBg:"bg0",
      honorOption:{
        slidesPerView: 3,
        spaceBetween: 30,
        centeredSlides: true,
        loop: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      },
      honorLists:[],
      teamStyleOption:{
        observer: true,  //开启动态检查器，监测swiper和slide
        observeParents: true,  //监测Swiper 的祖/父元素
        // speed: 3000,//切换速度
        loop:true,//循环
        slidesPerView:1,//显示数量
        spaceBetween:0,//间隔
        freeMode:true,//自动贴合
        autoplay: {//自动播放
          delay: 3000,//自动切换的时间间隔
          stopOnLastSlide: false,//切换到最后一个slide时停止自动切换
          disableOnInteraction: false,//用户操作后是否停止
        },
      },
      teamStyleLists:[],
      groupIntroduction:"",
      groupIntroductionPic:"",
      messageFromChairman:"",
      history:[],
      yearIndex:0,
      activeName: 'pane0',
    };
  },
  mounted() {
    var options = { live: false };
    new this.$wow.WOW(options).init();
    this.sectionOne=this.$t('about.culture.section')[0];
    
    const partId=this.$route.query.part;

    if(partId){
      this.$nextTick(()=>{
        document.querySelector("#"+partId).scrollIntoView({
          behavior: "smooth",
          block: "start",
          inline: "nearest",
        });
      })
    }
    // 1企业简介 2董事长寄语 3发展历程
    getstaticcontent(this.language,"1").then(res=>{
      console.log(res.data)
      if(res.data.length){
        this.groupIntroduction =  res.data[0].companyContent.split("\n");
        this.groupIntroductionPic = res.data[0].picturePath;
      }
      
    });
    getstaticcontent(this.language,"2").then(res=>{
      if(res.data.length){
        this.messageFromChairman = res.data[0].companyContent.split("\n");
      }
      
    });

    getstaticcontent(this.language,"3").then(res=>{
      this.history = res.data;
    });
    // 3员工风采 2公司奖章
    getpiclist(this.language,"3").then(res=>{
      if(res.data.length){
        this.teamStyleLists = res.data[0].picList;
      }
      
    });
    getpiclist(this.language,"2").then(res=>{
      if(res.data.length){
        this.honorLists = res.data[0].picList;
      }
    });

  },
  methods: {
    
    //锚点跳转
    goRule(event) {
      var id = "#" + event;
      document.querySelector(id).scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest",
      });
      if (this.active++ > 2) this.active = 0;
    },
    //监听滚动条
    onScroll(e) {
      let scrollItems = document.querySelectorAll(".scroll_content");
      for (let i = scrollItems.length - 1; i >= 0; i--) {
        console.log(i)
        // 判断滚动条滚动距离是否大于当前滚动项可滚动距离
        let judge = e.target.scrollTop >= scrollItems[i].offsetTop - scrollItems[0].offsetTop;
        //监听滚动条是否到底部
        const dom = document.getElementById('scrollElement');
        let scrollHeight = dom.clientHeight + dom.scrollTop >= dom.scrollHeight;
        if (judge) {
          this.active = i;
          if (scrollHeight) {
            //到达底部，步骤条完成
            this.active = i + 1;
            break;
          }
          break;
        }
      }
    },
    historyScroll(e){
      this.topNum=e.target.scrollTop; 
    },
    //关闭弹窗，重置元素
    closeDialog() {
      this.active = 0;
      this.$refs.myScroll.scrollTop = 0;
    },
    handleSection(i){
      this.sectionOne= this.$t('about.culture.section')[i];
      this.cultureBg= "bg"+i;
    },
    slideChange() {
      let swiperIndex = this.$refs.indexSwiper.swiper.activeIndex;
      this.yearIndex = swiperIndex;
    },
  },
};
</script>

<style scoped lang="scss">
.about{
  .company{
    h2 {
      position: relative;
      margin-bottom: 30px;
      font-weight: bold;
      .company-name {
        color: #000;
        font-size: 30px;
      }
      .line {
        color: #0052ac;
      }
      .name-tag {
        position: absolute;
        left: 100px;
        top: -16px;
        color: #d5d5d5;
        font-size: 28px;
        z-index: -1;
      }
    }
    .introduce{
        margin: 20px 0;
        line-height: 2;
        text-indent: 2em;
        text-align: justify;
    }

    .video{
      margin-top:30%;
    }  
  }
  .message-from-chairman{
    background: url(../../assets/img/about/msg_bg.png) no-repeat left/cover;
    color:#fff;
    margin-top:100px;
    .box{
      height:300px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding-left:20%;
      h2{
        margin-bottom:20px;
        font-size: 30px;
        position: relative;
        &::before{
          content:"“";
          display:block;
          font-size:140px;
          position: absolute;
          left:-60px;
          top:-50px;
          font-family: Arial; 
          opacity: 0.5;
        }
      }
      .des{
        line-height: 2;
        text-align: justify;
      }
    }
  }
  .history{
    margin-bottom:100px;
    .swiper-wrap{
      position: relative;
      padding-left:10px;
      .year{
        position: absolute;
        left:0;
        bottom:130px;
        color: #0052ac;
        font-size: 60px;
        font-weight: bold;
        transform: rotate(-90deg);
        transform-origin: left bottom;
      }
     .history-swiper {
        height: 600px; /* 设置Swiper容器的高度 */
        .swiper-slide {
          height: 200; /* 设置滑块的高度 */
          padding-right: 15px;
          box-sizing: border-box;
          p{
            text-align: justify;
          }
        }
      }
    }
    .pic{
      img{
        width:100%;
        height: 390px;
        object-fit: contain;
      }
    }
    .box-wrap{
      height:390px;
      overflow-y: auto;
      padding-right:20px;
      .box{
        margin-bottom:30px;
        h2{
          color:#0052ac;
        }
        p{
          text-align: justify;
        }
      }
    }

    ::v-deep .el-tabs__item{
      font-size: 24px;
      position: relative;
      top: 40px;
    }
    ::v-deep .el-tabs__nav-wrap{
      overflow:inherit;
    }
    ::v-deep .el-tabs__nav-scroll{
      overflow:inherit;
    }
    ::v-deep .el-tabs__nav-wrap::after{
      bottom:-40px;
    }

    /* 整个滚动条 */
    ::-webkit-scrollbar {
        /* 对应纵向滚动条的宽度 */
        width: 10px;
        /* 对应横向滚动条的宽度 */
        height: 10px;    
    }

    /* 滚动条上的滚动滑块 */
    ::-webkit-scrollbar-thumb {
        background-color: #49b1f5;
        border-radius: 32px;
    }

    /* 滚动条轨道 */
    ::-webkit-scrollbar-track {
        background-color: #dbeffd;
        border-radius: 32px;
    }

  }
  .culture{
    margin-bottom:80px;
    .culture-des{
      height:600px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      .culture-block{
        line-height: 2;
        h2{
          margin-bottom:20px;
        }
      }
      
    }
    .culture-row{
      height: 600px;
      color:#fff;
      border-radius: 50px;
      cursor: pointer;
      .el-col{
        height:100%;
        border-right:1px solid #fff;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .vertical{
          transform: rotate(-90deg);
        }
      }
      
      &:hover{
        transform: all;
        transition: 0.4s;
      }
    }
    .bg0{
      background: url(../../assets/img/about/0.jpg) no-repeat center/cover;
    }
    .bg1{
      background: url(../../assets/img/about/1.jpg) no-repeat center/cover;
    }
    .bg2{
      background: url(../../assets/img/about/2.jpg) no-repeat center/cover;
    }
    .bg3{
      background: url(../../assets/img/about/3.jpg) no-repeat center/cover;
    }
    .bg4{
      background: url(../../assets/img/about/4.jpg) no-repeat center/cover;
    }
    .bg5{
      background: url(../../assets/img/about/5.jpg) no-repeat center/cover;
    }
  }
  .honor{
    margin-bottom:80px;
    .first-row{
      margin-bottom:40px;
      .pic{
        img{
          object-fit: contain;
          width:100%;
        }
      }
    }
    // .honor-swiper{
    //   position: relative;
    //   height: 300px;
    //   .swiper-container {
    //     position: relative;
    //     width: 100%;
    //     height: 300px;
    //     .swiper-slide {
    //       text-align: center;
    //       font-size: 18px;
    //       background: #eee;
    //       display: flex;
    //       justify-content: center;
    //       align-items: center;
    //       transition: 300ms;
    //       transform: scale(0.8);
    //       img{
    //         width:100%;
    //         height:300px;
    //         object-fit: cover;
    //       }
    //     }
    //     .swiper-slide-active,.swiper-slide-duplicate-active{
    //       transform: scale(1);
    //     }
    //   }
    // }
  }
  .team-style{
    .team-style-box{
      width:70%;
      margin:0 auto;
      img{
        width:100%;
        height:500px;
        object-fit:contain;
      }
    }
  }
  @media screen and (max-width:768px){
    .company{
      h2 {
        margin-bottom: 20px;
        .company-name {
          font-size: 22px;
        }
        .name-tag {
          font-size: 20px;
          top: -12px;
        }
      }
      .video{
        margin-top:0;
      }
    }
    .message-from-chairman{

      margin-top:40px;
      .box{
        height:auto;
        padding:30px 15px;
        h2{
          &::before{
            display: none;
          }
        }

      }
    }
    .history{
      margin-bottom:0;
      ::v-deep .el-timeline-item__content{
        font-size: 20px;
        color:#0054a7;
        font-weight: bold;
      }
      ::v-deep .el-timeline-item__timestamp{
        font-size: 16px;
        line-height: 1.6;
      }
    }
    .honor{
      margin-bottom:0;
      .first-row{
        margin-bottom:0;
        .pic{
          padding:0 20px;
          margin-bottom:20px;
          img{
            object-fit: contain;
            width:100%;
          }
        }
      }
    }
    .team-style{
      .team-style-box{
        width:100%;
        img{
          width:100%;
          height:200px;
          object-fit:contain;
        }
      }
    }
  }
}

    // .el-divider--horizontal {
		// 	margin: 8px 0;
		// 	background: 0 0;
		// 	border-top: 1px dashed #e8eaec;
		// }
 
		// .el-dialog__wrapper {
		// 	overflow: hidden;
		// }
		// .scoll_box {
		// 	height: 380px;
		// 	overflow-y: scroll;
		// 	font-size: 15px;
		// }
 
		// .scoll_box>div {
		// 	margin-bottom: 10px;
		// }
 
		// .scoll_box>span {
		// 	font-size: 20px;
		// }
 
		// .scroll-item {
		// 	font-weight: bold;
		// 	font-size: 25px;
		// }
    // .scroll_content{
    //   height:400px;
    //   background:red;
    // }


</style>